import { request } from "../../api/API"
import { multipartRequest } from "../../api/API"

export const updatePassword = (data) => {
    return multipartRequest.post('/changePassword/', data);
}

